import { Box, CircularProgress, Typography } from '@mui/material';
import React from 'react';

export const LoadingPage = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: '16px',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
      }}
    >
      <CircularProgress />
      <Typography variant="h6">Cargando...</Typography>
    </Box>
  );
};
